import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242bcdcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "menu-section" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = ["onMouseover", "onClick"]
const _hoisted_6 = { class: "menu-section-hamburger" }
const _hoisted_7 = { class: "ham-menu-links" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "drop-down-links" }

import { ref } from "vue";
  import router  from "@/router";
  
  import { onMounted, onUnmounted, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
    screenName: {}
  },
  setup(__props: any) {

  const props = __props;

  let menuItems: any = [
    {
      key: "1",
      label: "CAPABILITIES",
      categories: [
        {link:'application-modernization', category: "Application Modernization"},
        {link:'business-intelligence', category: "Business Intelligence"},
        {link:'cloud', category: "Cloud"},
        {link:'cyber-security', category: "Cyber Security"},
        {link:'devsecops', category: "DevSecOps"},
        {link:'digital-services', category: "Digital Services"},
        {link:'health-it-services', category: "Health IT Services"},
        {link:'national-security-services', category: "National Security Services"},
        {link:'program-management', category: "Program Management and Strategy"},
      ],
    },
    {
      key: "2",
      label: "SOLUTIONS",
      categories: [
        {link:'complySync-ato', category: "ComplySync ATO"},
        {link:'debt-management', category: "Debt Management"},
        {link:'security-data-lake', category: "Security Data Lake"},
        {link:'test-automation-platform', category: "Test Automation Platform"},
        {link:'hephaestus', category: "Hephaestus"}
      ],
    },
    {
      key: "3",
      label: "SECTORS",
      categories: [
        {link:'banking-and-finance', category: "Banking and Finance"},
        {link:'federal-civilian', category: "Federal Civilian"},
        {link:'health-care', category: "Healthcare"},
        {link:'national-security', category: "National Security"},
        {link:'reg-tech', category: "RegTech"},
        {link:'state-and-local-government', category: "State and Local Goverment"},
      ],
    },
    {
      key: "4",
      label: "CONTRACT VEHICLES",
      categories: [],
      link: "contract-vehicles"
    },
    {
      key: "5",
      label: "ABOUT US",
      categories: [],
      link:"about-us"
    },
    { key: "6", label: "CONTACT US", categories: [], link:"contact-us" },
  ];

  const activeMenu = ref<any>(null);

  let hideMenuTimeout: any = null;
  let menu = ref<any>(false);

  let hamMenu = ref<any>(false);
  let hamSubMenu = ref<any>(false);

  const showMenu = (item: any) => {
    clearHideMenuTimeout();
    activeMenu.value = item;
    menu.value = true;
  };

  const scheduleHideMenu = () => {
    hideMenuTimeout = setTimeout(() => {
      activeMenu.value = null;
      menu.value = false;
    }, 1000);
  };

  const clearHideMenuTimeout = () => {
    if (hideMenuTimeout) {
      clearTimeout(hideMenuTimeout);
      hideMenuTimeout = null;
    }
  };

  function hambergerMenu(){
    hamMenu.value = true;
    activeMenu.value = null;
  }

  function hamMenuItemClick(item: any){
    activeMenu.value = item;
    hamSubMenu.value = !hamSubMenu.value;
  }

  function subMenuBack(){
    hamSubMenu.value = !hamSubMenu.value;
    hamMenu.value = true;
    activeMenu.value = null;
  }

  function menuClick(item: any){
    if(item.categories.length === 0 && item.link){
      router.push({ name: item.link })
      window.scrollTo(0, 0);
    }
  }
  
  function routeToLink(link: any){
    router.push({ name: link })
    window.scrollTo(0, 0);
  }

  const windowWidth = ref(window.innerWidth);

  const handleResize = () => {
    windowWidth.value = window.innerWidth;
  };

  const isMobile = ref(false);

  const checkIfMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      isMobile.value = true;
      return;
    }

    if (/Windows Phone/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/BB10|BlackBerry/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/webOS|Palm/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    isMobile.value = false;
  };

  onMounted(() => {
    window.addEventListener('resize', handleResize);
    checkIfMobile();
    screenType(props.screenName);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  watch(windowWidth, (newWidth, oldWidth) => {
    if (newWidth > 990 && oldWidth <= 990 && hamSubMenu.value === true) {
      subMenuBack();
    }
  });

  const screenType = (screenName: string) => {
    // alert(isMobile.value ? "Mobile" : "Desktop")
    const oldStyle = document.getElementById('dynamic-media-queries');
    if(oldStyle){
      oldStyle.remove();
    }

    let maxWidth = isMobile.value ? '1179' : '990';
    let minWidth = isMobile.value ? '1180' : '991';
    if(screenName === 'complySync'){
      maxWidth = isMobile.value ? '1179' : '1230';
      minWidth = isMobile.value ? '1180' : '1231';
    }

    let mediaQuery = `
      @media (max-width: ${maxWidth}px) {
        .mymenu >>> .v-overlay__content {
          width: 700px !important;
          margin-left: calc(100% - 732px) !important;
        }
        .menu-section-hamburger {
          display: block !important;
        }
        .menu-section {
          display: none !important;
        }
        .ham-menu-style {
          display: block !important;
        }
        .ham-submenu-style {
          display: block !important;
        }
        .mymenu {
          visibility: hidden !important;
        }
      }
      @media (min-width: ${minWidth}px) {
        .menu-section-hamburger {
          display: none !important;
        }
        .menu-section {
          display: block !important;
        }
        .ham-menu-style {
          display: none !important;
        }
        .ham-submenu-style {
          display: none !important;
        }
      }
    `;

    const styleTag = document.createElement('style');
    styleTag.id = 'dynamic-media-queries';
    styleTag.textContent = mediaQuery;
    document.head.appendChild(styleTag);
  };

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_v_app_bar, {
      elevation: "4",
      class: "app-bar-style"
    }, {
      prepend: _withCtx(() => [
        _createElementVNode("img", {
          src: require(`@/assets/header/logo.png`),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (routeToLink('home'))),
          alt: "Logo",
          class: "logo-image"
        }, null, 8, _hoisted_1),
        (_ctx.screenName === 'complySync')
          ? (_openBlock(), _createBlock(_component_v_divider, {
              key: 0,
              vertical: "",
              class: "border-opacity-50 ml-5 mt-2",
              length: "47px",
              color: "#8f8f8f"
            }))
          : _createCommentVNode("", true),
        (_ctx.screenName === 'complySync')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: require(`@/assets/solutions/comply-sync/ComplySyncATO logo.png`),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (routeToLink('home'))),
              alt: "Logo",
              class: "sub-logo-image"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      append: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
              return (_openBlock(), _createElementBlock("h3", {
                key: item.key,
                class: _normalizeClass(["mr-6 ml-6 menu-items", activeMenu.value ? (item.label === activeMenu.value.label ? 'menu-item-hover' : '') : '']),
                onMouseover: ($event: any) => (showMenu(item)),
                onMouseleave: scheduleHideMenu,
                onClick: ($event: any) => (menuClick(item))
              }, _toDisplayString(item.label), 43, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (hambergerMenu())),
            icon: (_unref(hamMenu) || _unref(hamSubMenu)) ? 'mdi-window-close' : 'mdi-menu'
          }, null, 8, ["icon"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_menu, {
      modelValue: _unref(hamMenu),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(hamMenu) ? (hamMenu).value = $event : hamMenu = $event)),
      class: "ham-menu-style"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "ham-menu-card-style" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                (_unref(menuItems))
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: 12,
                            xs: 12,
                            sm: 12,
                            key: item,
                            class: "ham-menu-items",
                            onClick: ($event: any) => (item.categories.length > 0 ? hamMenuItemClick(item) : (item.link ? menuClick(item) : ''))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_7, _toDisplayString(item.label), 1),
                              (item.categories.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    icon: "mdi-chevron-right",
                                    color: "#969696"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_menu, {
      modelValue: _unref(hamSubMenu),
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(hamSubMenu) ? (hamSubMenu).value = $event : hamSubMenu = $event)),
      class: "ham-submenu-style"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "ham-submenu-card-style" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (subMenuBack())),
              class: "back-icon"
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                (activeMenu.value && activeMenu.value.categories)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeMenu.value.categories, (item) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: 12,
                            xs: 12,
                            sm: 12,
                            key: item,
                            class: "ham-submenu-items"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (item.link !== '' ? routeToLink(item.link) : ''),
                                class: "ham-submenu-links"
                              }, _toDisplayString(item.category), 9, _hoisted_8)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (activeMenu.value !== null ? activeMenu.value.categories.length > 0 : false)
      ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0,
          modelValue: _unref(menu),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(menu) ? (menu).value = $event : menu = $event)),
          class: _normalizeClass(["mymenu", activeMenu.value.label === 'CAPABILITIES' ? 'capability-menu' : (activeMenu.value.label === 'SOLUTIONS' ? 'solutions-menu' : 'sectors-menu')]),
          onMouseover: clearHideMenuTimeout,
          onMouseleave: scheduleHideMenu,
          transition: "slide-y-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "card-style" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_actions, { class: "card-style-action" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeMenu.value !== null ? activeMenu.value.categories : [], (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        style: {"text-align":"left"},
                        class: "card-menu-item",
                        onClick: ($event: any) => (item.link !== '' ? routeToLink(item.link) : '')
                      }, [
                        _createElementVNode("a", _hoisted_10, _toDisplayString(item.category), 1)
                      ], 8, _hoisted_9))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})